import { cloneDefaultConfig, defaultStats } from "./config";
import type { AdminSettings, SiteConfig, Stats, VariantId } from "./types";

export async function fetchConfig(): Promise<SiteConfig> {
  const res = await fetch("/api/config", { credentials: "include" }).catch(() => undefined);
  if (!res || !res.ok) return cloneDefaultConfig();
  return res.json();
}

export async function fetchAdminSettings(): Promise<AdminSettings> {
  const res = await fetch("/api/admin/settings", { credentials: "include" });
  if (!res.ok) return { config: cloneDefaultConfig(), stats: defaultStats, media: [] };
  return res.json();
}

export async function publishConfig(config: SiteConfig): Promise<AdminSettings> {
  const res = await fetch("/api/admin/publish", {
    method: "POST",
    credentials: "include",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(config)
  });
  if (!res.ok) throw new Error("Publish failed");
  return res.json();
}

export async function uploadAsset(file: File): Promise<AdminSettings> {
  const body = new FormData();
  body.append("file", file);
  const res = await fetch("/api/admin/upload", { method: "POST", credentials: "include", body });
  if (!res.ok) throw new Error("Upload failed");
  return res.json();
}

export function trackEvent(variant: VariantId, type: "view" | "contact", locale: string) {
  const params = new URLSearchParams(location.search);
  return fetch("/api/event", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      variant,
      type,
      locale,
      utm_source: params.get("utm_source") || "",
      utm_campaign: params.get("utm_campaign") || "",
      path: location.pathname
    }),
    keepalive: true
  }).catch(() => undefined);
}

export type { AdminSettings, Stats };
